export default __webpack_public_path__ + "static/media/ad_display.fdaa217b.svg";